// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-input {
    border: none;
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
    font-size: 16px;
    -webkit-appearance: none;
    appearance: none;
    outline-offset: -1px;
    height: 100%;
    background: none;
    text-align: left;
    display: block;
    font-family: inherit;
    border-radius: var(--survey-input-border-radius, 2px);
}

.survey-input.survey-input-v2 {
    border: var(--v2-input-border);
    border-radius: 6px;
    padding: 12px 16px;
    line-height: 21px;
    height: 46px;
}

.survey-input::placeholder {
    color: var(--survey-placeholder-color);

    /* Firefox */
    opacity: 1;
}

.survey-input-value-button,
.survey-input-placeholder-button {
    width: 100%;
    font-size: 16px;
    height: 100%;
    padding: 10px;
    color: var(--survey-placeholder-color);
    font-family: inherit;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.survey-input-value-button {
    color: #000;
}

.survey-input-placeholder-button.survey-input-placeholder-button-v2,
.survey-input-value-button.survey-input-value-button-v2 {
    border: var(--v2-input-border);
    border-radius: 6px;
    padding: 12px 16px;
    line-height: 21px;
    height: 45px;
}

/* iOS Safari Styles for Date Inputs */
.survey-input::-webkit-date-and-time-value,
.survey-input::-webkit-date-and-time-value {
    text-align: left;
}

/* Hack to fix autofill issue on Chrome/iOS */
@keyframes autoFillAnimation {
  from {}
  to {}
}

input[chrome-autofilled], /* this selector really did the trick */
input:autofill,
input:-webkit-autofill {
  animation-name: autoFillAnimation;
  animation-duration: 1ms;
}

/* helps time not get cut off by calendar icon that opens the picker */
.survey-form-item-label-left .survey-input.survey-input-v2[type="date"],
.survey-form-item-label-left .survey-input.survey-input-v2[type="datetime-local"],
.survey-form-item-label-left .survey-input.survey-input-v2[type="time"] {
    padding-right: 4px;
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Survey/Components/SurveyInput/SurveyInput.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,qDAAqD;AACzD;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,sCAAsC;;IAEtC,YAAY;IACZ,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA,sCAAsC;AACtC;;IAEI,gBAAgB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,MAAM;EACN,IAAI;AACN;;AAEA;;;EAGE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA,sEAAsE;AACtE;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;AACb","sourcesContent":[".survey-input {\n    border: none;\n    padding: 10px;\n    width: 100%;\n    box-sizing: border-box;\n    font-size: 16px;\n    -webkit-appearance: none;\n    appearance: none;\n    outline-offset: -1px;\n    height: 100%;\n    background: none;\n    text-align: left;\n    display: block;\n    font-family: inherit;\n    border-radius: var(--survey-input-border-radius, 2px);\n}\n\n.survey-input.survey-input-v2 {\n    border: var(--v2-input-border);\n    border-radius: 6px;\n    padding: 12px 16px;\n    line-height: 21px;\n    height: 46px;\n}\n\n.survey-input::placeholder {\n    color: var(--survey-placeholder-color);\n\n    /* Firefox */\n    opacity: 1;\n}\n\n.survey-input-value-button,\n.survey-input-placeholder-button {\n    width: 100%;\n    font-size: 16px;\n    height: 100%;\n    padding: 10px;\n    color: var(--survey-placeholder-color);\n    font-family: inherit;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.survey-input-value-button {\n    color: #000;\n}\n\n.survey-input-placeholder-button.survey-input-placeholder-button-v2,\n.survey-input-value-button.survey-input-value-button-v2 {\n    border: var(--v2-input-border);\n    border-radius: 6px;\n    padding: 12px 16px;\n    line-height: 21px;\n    height: 45px;\n}\n\n/* iOS Safari Styles for Date Inputs */\n.survey-input::-webkit-date-and-time-value,\n.survey-input::-webkit-date-and-time-value {\n    text-align: left;\n}\n\n/* Hack to fix autofill issue on Chrome/iOS */\n@keyframes autoFillAnimation {\n  from {}\n  to {}\n}\n\ninput[chrome-autofilled], /* this selector really did the trick */\ninput:autofill,\ninput:-webkit-autofill {\n  animation-name: autoFillAnimation;\n  animation-duration: 1ms;\n}\n\n/* helps time not get cut off by calendar icon that opens the picker */\n.survey-form-item-label-left .survey-input.survey-input-v2[type=\"date\"],\n.survey-form-item-label-left .survey-input.survey-input-v2[type=\"datetime-local\"],\n.survey-form-item-label-left .survey-input.survey-input-v2[type=\"time\"] {\n    padding-right: 4px;\n}\n\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
